import React from 'react';
import DividendTransactionsVM from './DividendTransactionsVM';
import { observer } from 'mobx-react';
import { Neo, NeoGrid } from '@singularsystems/neo-react';
import { TextConstants } from '../../../Common/TextConstants';
import DividendTransactionsLookup from '../Models/Lookups/DividendTransactionsLookup';
import { dateFormat, dateFormatYYYYMMDD } from '../../../Common/Components/Helpers/Formatting';

interface IDividendTransactionsProps {
    viewModel: DividendTransactionsVM;
}

@observer
export default class DividendTransactions extends React.Component<IDividendTransactionsProps> {

    constructor(props: IDividendTransactionsProps) {
        super(props);
    }

    public render() {
        const viewModel = this.props.viewModel;

        return (
          <>
          <Neo.Card>
            {viewModel.dividendTransactionsPageManager.totalRecords > 0 &&
                <div className="inner-container">
                  <Neo.Pager
                    pageManager={viewModel.dividendTransactionsPageManager}
                    pageControlProps={{ pageSizeLabel: "Show" }}
                  >
                    <div className="horizontalScroll inner-container">
                      <NeoGrid.Grid<DividendTransactionsLookup> className={"table-striped"}>
                        {(item, meta) => (
                          <NeoGrid.RowGroup>
                            <NeoGrid.Row>
                              <NeoGrid.Column display={meta.brokerAccountNumber} label={TextConstants.Labels.BrokerAccountNumber} />
                              <NeoGrid.Column display={meta.instrument} label={TextConstants.Labels.Instrument} />
                              <NeoGrid.Column display={meta.eventDetail} label={TextConstants.Labels.EventDetail} />
                              <NeoGrid.Column display={meta.eventId} label={TextConstants.Labels.EventID} />
                              <NeoGrid.Column label={TextConstants.Labels.EventDate} >
                                  {dateFormatYYYYMMDD(item.eventDate)}
                                </NeoGrid.Column>
                              <NeoGrid.Column display={meta.amountNC} label={TextConstants.Labels.AmountNC}/>
                              <NeoGrid.Column display={meta.excluded} label={TextConstants.Labels.Excluded} />                             
                            </NeoGrid.Row>
                          </NeoGrid.RowGroup>
                        )}
                      </NeoGrid.Grid>
                    </div>
                  </Neo.Pager>
                </div>
                }
                {viewModel.dividendTransactionsPageManager.totalRecords <= 0 && (
                  <div className="col-md-12 p-0 text-center">
                    {TextConstants.GeneralText.NoRecords}
                  </div>
                )}
              </Neo.Card>            
          </>
        );
    }
}